import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkareaService } from '../../services/workarea/workarea.service';
import { Status } from '../../status.interface';
import { WorkareaHistory } from '../../workarea-history.interface';
import { Workarea } from '../../workarea.class';

@Component({
    selector: 'app-workarea-history-dialog',
    templateUrl: './workarea-history-dialog.component.html',
    standalone: false,
})
export class WorkareaHistoryDialogComponent implements OnInit {
    workarea: Workarea;
    history: WorkareaHistory[];
    fieldTranslations: {};
    statuses: Status[];

    booleans = ['extra.klinkerfloor', 'extra.reinforcementgrid'];

    constructor(
        private workareaService: WorkareaService,
        private dialog: MatDialogRef<WorkareaHistoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: {
            workarea: Workarea;
            fieldTranslations: {};
            statuses: Status[];
        }
    ) {
        this.workarea = data.workarea;
        this.fieldTranslations = data.fieldTranslations;
        this.statuses = data.statuses;
    }

    ngOnInit(): void {
        this.workareaService.getHistory(this.workarea.id).subscribe(history => {
            this.history = history.data;
            this.history.forEach(item => {
                if (this.booleans.indexOf(item.field) !== -1) {
                    item.old = item.old === '1' ? 'Ja' : 'Nee';
                    item.new = item.new === '1' ? 'Ja' : 'Nee';
                }
                if (item.field === 'status_id') {
                    item.old = this.statuses.find(s => s.id === +item.old)?.name;
                    item.new = this.statuses.find(s => s.id === +item.new)?.name;
                }
                if (item.field.substring(0, 5) === 'extra') {
                    item.field = this.fieldTranslations[item.field.substring(6)];
                } else {
                    item.field = this.fieldTranslations[item.field];
                }
            });
        });
    }
}
